import { ApolloClient } from "apollo-client";
import { createUploadLink } from "apollo-upload-client";
import { InMemoryCache } from "apollo-cache-inmemory";
import { ApolloLink } from "apollo-link";
import store from "./store";

import { onError } from "apollo-link-error";

const errorLink = onError(({ graphQLErrors, networkError }) => {
  if (graphQLErrors)
    graphQLErrors.map(({ message, locations, path }) =>
      console.error(
        `[GraphQL error]: Message: ${message}, Location: ${locations}, Path: ${path}`
      )
    );

  if (networkError) {
    console.error(`[Network error]: ${networkError}`);
    store.dispatch("generalError", networkError.toString());
  }
});

const uploadLink = createUploadLink({
  // You should use an absolute URL here
  uri: process.env.VUE_APP_APIHOST + "/graphql/",
});

//Middleware for Authorization
const authLink = new ApolloLink((operation, forward) => {
  if (store.getters.getToken) {
    operation.setContext({
      headers: {
        Authorization: "JWT " + store.getters.getToken,
      },
    });
  }
  return forward(operation);
});

const links = [errorLink, authLink];
// Dev-only: answer the Medium-Term Forecaster operations from fixtures.
// The condition is a build-time constant, so production bundles drop this block.
if (process.env.VUE_APP_FORECAST_V2_MOCK === "true") {
  const { createForecastMockLink } = require("./modules/forecast-tool/mock/mockLink");
  links.push(createForecastMockLink());
  console.warn("[janus] Forecast tool is running on illustrative fixtures (VUE_APP_FORECAST_V2_MOCK=true).");
}
links.push(uploadLink);
const link = ApolloLink.from(links);

// Cache implementation
const cache = new InMemoryCache();

// Create the apollo client
const apolloClient = new ApolloClient({
  link: link,
  cache,
});

export default apolloClient;
